<template>
  <div id="app">
    <!-- <div v-html="header"></div> -->
    <!-- <div id="nav">
      <ul class="breadcrumbs">
        <li><img src="" alt=""><a href="https://www.brighton.com">Home</a></li>
        <li><img src="" alt=""><a href="https://www.brighton.com">Brighton Your Way Personalized Lockets</a></li>
      </ul> -->
    <!-- </div> -->

    <router-view/>
    <!-- <div v-html="footer"></div> -->
  </div>
</template>

<script>
  export default {
    name: 'locket-app',
    data () {
      return {
         test: 'hello',
         footer:'',
         header:''
      }
    },
    methods: {
    },
    mounted(){
      // console.log(baseURL)
    }
  }
</script>

<style>

#app {
  transition: all 0.3s;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-bottom:100px;
}
#admin-bar-iframe{
  display:none;
}
/*#nav {
    position: relative;
    max-width: 1170px;
    width: auto;
    margin: 0 auto 0px auto;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
#nav ul.breadcrumbs{
  display: block;
    list-style-type: none;
    text-align: left;
}
#nav ul.breadcrumbs li {
  display: inline-block;
  line-height:1;
}
#nav ul.breadcrumbs li a {
  font-weight:normal;
  display: block;
  background: url(https://www.brighton.com/store_image/site/arrow.gif) no-repeat;
  padding-left: 9px;
  background-position: 0 50%;
  margin-right: 12px;
}*/
</style>
